import { MoreHorizontal, Play, Home, Search, Heart, Smile, ChevronRight } from "lucide-react";
import { EPISODES, IMG } from "@/data/content";

const seoul = EPISODES.find((e) => e.code === "SEL") || EPISODES[7];
const saved = [EPISODES[0], EPISODES[3], EPISODES[11]];
const later = [EPISODES[1], EPISODES[11]];

// Maqueta de la app (segunda pantalla) para /la-app
export const PhoneMockup = () => (
  <div className="relative w-[300px]">
    <div className="pointer-events-none absolute -inset-8 rounded-[3.5rem] bg-gradient-to-br from-mint/50 via-sky/30 to-coral/40 blur-2xl" />
    <div className="relative rounded-[2.8rem] bg-ink p-2.5 shadow-[0_30px_60px_rgba(0,0,0,0.28)]">
      <div className="absolute left-1/2 top-2.5 z-10 h-5 w-28 -translate-x-1/2 rounded-b-2xl bg-ink" />
      <div className="relative overflow-hidden rounded-[2.3rem] bg-cream">
        {/* barra de estado */}
        <div className="flex items-center justify-between px-6 pt-3 pb-1">
          <span className="font-mono text-[10px] font-semibold text-ink">9:41</span>
          <div className="flex items-center gap-1">
            <span className="h-2 w-3 rounded-sm bg-ink/70" />
            <span className="h-2 w-2 rounded-full bg-ink/70" />
            <span className="h-2 w-4 rounded-sm bg-ink/70" />
          </div>
        </div>

        <div className="px-5 pb-5">
          {/* header */}
          <div className="flex items-center justify-between pt-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-coral font-display text-sm font-extrabold text-white">
                B
              </span>
              <div className="leading-none">
                <p className="font-display text-sm font-bold text-ink">Bella</p>
                <p className="font-mono text-[8px] uppercase tracking-widest text-ink/40">
                  Serie 01
                </p>
              </div>
            </div>
            <MoreHorizontal className="h-5 w-5 text-ink/50" />
          </div>

          {/* saludo */}
          <div className="mt-5 flex items-end justify-between">
            <div>
              <p className="font-mono text-[10px] uppercase tracking-widest text-coral">
                Hola, viajera
              </p>
              <h3 className="mt-1 font-display text-2xl font-extrabold leading-[0.95] tracking-tight text-ink">
                ¿Dónde
                <br />
                miramos hoy?
              </h3>
            </div>
            <img
              src={IMG.bellaPortrait}
              alt=""
              className="h-12 w-12 rounded-full object-cover ring-2 ring-white"
            />
          </div>

          {/* hero */}
          <div className="relative mt-4 overflow-hidden rounded-2xl">
            <img src={seoul.img} alt={seoul.city} className="h-44 w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/50 to-transparent" />
            <button className="absolute bottom-3 left-3 inline-flex items-center gap-1.5 rounded-full bg-gold px-3 py-1.5 font-mono text-[10px] font-bold uppercase tracking-widest text-ink">
              <Play className="h-3 w-3 fill-ink" /> Ver avance
            </button>
          </div>

          {/* guardados */}
          <div className="mt-5 flex items-center justify-between">
            <p className="font-display text-sm font-bold text-ink">Destinos guardados</p>
            <span className="font-mono text-[9px] uppercase tracking-widest text-coral">
              Ver todo
            </span>
          </div>
          <div className="mt-3 grid grid-cols-3 gap-2">
            {saved.map((s) => (
              <div key={s.n}>
                <div className="overflow-hidden rounded-xl">
                  <img src={s.img} alt={s.city} className="h-16 w-full object-cover" />
                </div>
                <p className="mt-1 truncate font-mono text-[8px] uppercase tracking-wider text-ink/50">
                  {s.city}
                </p>
              </div>
            ))}
          </div>

          {/* para ver después */}
          <div className="mt-5 flex items-center justify-between">
            <p className="font-display text-sm font-bold text-ink">Para ver después</p>
            <span className="font-mono text-[9px] uppercase tracking-widest text-coral">
              Más episodios
            </span>
          </div>
          <div className="mt-3 space-y-2">
            {later.map((l) => (
              <div key={l.n + l.city} className="flex items-center gap-3 rounded-xl bg-mist p-2">
                <img src={l.img} alt="" className="h-9 w-9 rounded-lg object-cover" />
                <div className="min-w-0 flex-1">
                  <p className="truncate font-mono text-[8px] uppercase tracking-wider text-ink/40">
                    Ep {l.n} · {l.title}
                  </p>
                  <p className="truncate font-display text-xs font-bold text-ink">{l.city}</p>
                </div>
                <ChevronRight className="h-4 w-4 text-ink/30" />
              </div>
            ))}
          </div>
        </div>

        {/* nav inferior */}
        <div className="flex items-center justify-around border-t border-ink/10 bg-white px-4 py-3">
          {[
            { i: Home, l: "Inicio", a: true },
            { i: Search, l: "Explorar" },
            { i: Heart, l: "Guardados" },
            { i: Smile, l: "Bella" },
          ].map((n) => (
            <div key={n.l} className="flex flex-col items-center gap-1">
              <n.i className={`h-4 w-4 ${n.a ? "text-coral" : "text-ink/40"}`} />
              <span
                className={`font-mono text-[7px] uppercase tracking-wider ${
                  n.a ? "text-coral" : "text-ink/40"
                }`}
              >
                {n.l}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);
